import { defineStore } from 'pinia'
import http from '../http.js'

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        returnUrl: null
    }),
    actions: {
        
        async login(username, password) {
           
            const user = await http.post('/login', { username, password });

            // update pinia state
            this.user = user;

            // store user details and jwt in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));

            // redirect to previous url or default to home page
            window.location.href = this.returnUrl || '/'
           // this.$router.push(this.returnUrl || '/'); //TODO
        },
        logout() {
            this.user = null;
            localStorage.removeItem('user');
            window.location.href ='user/UserLogin'
          // this.router.push('/login'); //TODO
        }
    }
});

